import './vertical-stack.scss';
